import React, {useState} from 'react';
import {Alert,Box} from '@mui/material';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import VideoUpload from './VideoUpload';
import StepInformationForm, { MediaMetadataFormData } from './StepInformationForm';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AudiotrackOutlinedIcon from '@mui/icons-material/AudiotrackOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import SmartDisplayOutlinedIcon from '@mui/icons-material/SmartDisplayOutlined';

const steps = ['Agregar Información', 'Subir Media'];

interface VideoUploadStepperProps {
  mediaType?: 'all' | 'video' | 'audio' | 'pdf';
}

const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: '90vw',
    maxWidth:'600px',
    color:'black',
    bgcolor: "#FFFFFF",
    boxShadow: "0 8px 32px 0 rgba( 31, 38, 135, 0.37 )",
    border: "1px solid rgba( 255, 255, 255, 0.18 )",
    p: 2,
    borderRadius: 5,
    backdropFilter:'blur(4px)',
    zIndex:10,
  };

export default function VideoUploadStepper({ mediaType = 'all' }: VideoUploadStepperProps) {
  const [activeStep, setActiveStep] = useState(0);
  const [selectedMediaType, setSelectedMediaType] = useState<'video' | 'audio' | 'pdf'>(mediaType === 'all' ? 'video' : mediaType);
  const [metadata, setMetadata] = useState<MediaMetadataFormData>({
    title: '',
    description: '',
    tags: [],
    duration: 0,
    intensityLevel: '',
    seriesId: '',
    seriesEpisodeId: null,
    allowedSubscriptions: [],
  });

  const getMediaIcon = () => {
    if (selectedMediaType === 'audio') {
      return <AudiotrackOutlinedIcon sx={{ fontSize: 18 }} />;
    }

    if (selectedMediaType === 'pdf') {
      return <PictureAsPdfOutlinedIcon sx={{ fontSize: 18 }} />;
    }

    return <SmartDisplayOutlinedIcon sx={{ fontSize: 18 }} />;
  };

  const getMediaTypeLabel = () => {
    if (selectedMediaType === 'audio') return 'Audio';
    if (selectedMediaType === 'pdf') return 'PDF';
    return 'Video';
  };


  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <StepInformationForm
            handleNext={handleNext}
            mediaType={mediaType}
            selectedMediaType={selectedMediaType}
            onMediaTypeChange={setSelectedMediaType}
            onSave={setMetadata}
            initialData={metadata}
          />
        );
      case 1:
        return (
          <VideoUpload
            metadata={metadata}
            mediaType={selectedMediaType}
            onBack={handleBack}
            onComplete={handleNext}
          />
        );
      default:
        return <Typography>Unknown step</Typography>;
    }
  };

  const handleReset = () => {
    setActiveStep(0);
    setMetadata({
      title: '',
      description: '',
      tags: [],
      duration: 0,
      intensityLevel: '',
      seriesId: '',
      seriesEpisodeId: null,
      allowedSubscriptions: [],
    });
  };

  return (
    <Box sx={modalStyle}>
      <div className="mb-4 rounded-xl border border-[#d8ecee] bg-[#f4f6f8] px-4 py-3">
        <div className="flex items-center justify-between gap-3">
          <div>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#2e5355' }}>
              Flujo de carga de media
            </Typography>
            <Typography variant="body2" sx={{ color: '#6b7280' }}>
              Completa los pasos para registrar y publicar contenido.
            </Typography>
          </div>
          <span className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1 text-xs font-semibold uppercase tracking-[0.08em] text-[#2e5355] border border-[#b0d8dc]">
            {getMediaIcon()}
            {getMediaTypeLabel()}
          </span>
        </div>
      </div>

      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: {
            optional?: React.ReactNode;
          } = {};

          const isFirstStep = index === 0;
          const stepIcon = isFirstStep ? <DescriptionOutlinedIcon sx={{ fontSize: 18 }} /> : <PermMediaOutlinedIcon sx={{ fontSize: 18 }} />;

          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>
                <span className="inline-flex items-center gap-2">
                  {stepIcon}
                  {label}
                </span>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <React.Fragment>
        <div className="flex justify-center items-center p-5">
          <Alert severity="success">Todos los pasos se han completado de forma exitosa !!!</Alert>
        </div>
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button onClick={handleReset}>Inciar</Button>
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
            
        <div className='flex flex-col p-5'>
            {getStepContent(activeStep)}
         </div>
          
        </React.Fragment>
      )}
    </Box>
  );
}